<template>
  <div class="home">
    <barra />

    <main id="main">
         <recupero />
    </main>

 
  </div>
</template>

<script>
import barra from "@/components/barra/index.vue";
import recupero from "@/components/botonPago/restorepass/index.vue";

export default {
  name: "recuperarobp",
  components: {
    recupero,
    barra,
  },
};
</script>
